
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'


export const FORM_REQUEST_SENT = 'FORM_REQUEST_SENT'
export const FORM_REQUEST_SUCCESS = 'FORM_REQUEST_SUCCESS'
export const FORM_REQUEST_ERROR = 'FORM_REQUEST_ERROR'
export const FORM_REQUEST_FINISHED = 'FORM_REQUEST_FINISHED'

export const DATA_REQUEST_SENT = 'DATA_REQUEST_SENT'
export const DATA_REQUEST_SUCCESS = 'DATA_REQUEST_SUCCESS'
export const DATA_REQUEST_ERROR = 'DATA_REQUEST_ERROR'


export const SIGNIN_SUCCESSFULL = 'SIGNIN_SUCCESSFULL'
export const LOGOUT = 'LOGOUT'
export const SIGNUP_SUCCESSFULL = 'SIGNUP_SUCCESSFULL'


export const SUPERUSER_DATA_SUCCESS = 'SUPERUSER_DATA_SUCCESS'
export const CHANGE_USER_DETAILS_SUCCESS_SUPERUSER = 'CHANGE_USER_DETAILS_SUCCESS_SUPERUSER'

export const LOAD_USERPROFILES_SUCCESS = 'LOAD_USERPROFILES_SUCCESS'
export const UPDATE_USERPROFILE_SUCCESS = 'UPDATE_USERPROFILE_SUCCESS'

export const GEOCODE_SUCCESS = 'GEOCODE_SUCCESS'
export const GEOCODE_ERROR = 'GEOCODE_ERROR'

export const LOAD_PILOTAREAS_SUCCESS = 'LOAD_PILOTAREAS_SUCCESS'
export const LOAD_PROFESSIONALGROUPS_SUCCESS = 'LOAD_PROFESSIONALGROUPS_SUCCESS'
export const LOAD_TAGS_SUCCESS = 'LOAD_TAGS_SUCCESS'
export const LOAD_GLOSSARY_SUCCESS = 'LOAD_GLOSSARY_SUCCESS'
export const LOAD_TOPICS_SUCCESS = 'LOAD_TOPICS_SUCCESS'
export const LOAD_CONTENT_SUCCESS = 'LOAD_CONTENT_SUCCESS'
export const ADD_CONTENT_SUCCESS = 'ADD_CONTENT_SUCCESS'
export const LOAD_EVENTS_SUCCESS = 'LOAD_EVENTS_SUCCESS'
export const ADD_EVENTS_SUCCESS = 'ADD_EVENTS_SUCCESS'
export const LOAD_PAGES_SUCCESS = 'LOAD_PAGES_SUCCESS'
export const LOAD_SITECONTENT_SUCCESS = 'LOAD_SITECONTENT_SUCCESS'


export const GET_LAYERS_SUCCESS = 'GET_LAYERS_SUCCESS'

export const SET_COOKIE = 'SET_COOKIE'
export const DELETE_COOKIE = 'DELETE_COOKIE'
export const ALLOW_COOKIES = 'ALLOW_COOKIES'


// WEBPACK FOOTER //
// ./src/actions/types.js